import React from 'react';
import times from 'lodash/times';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';
import { Card } from '../../../../CommonComponents/OPL/Card/Card';
import { Shimmer } from '../../../../CommonComponents/OPL/Shimmer/Shimmer';
import { GridWrapper } from '../GridWrapper/GridWrapper';

export const GoalsListLoading = () => {
  return (
    <GridWrapper>
      {times(3).map(index => (
        <Box as="li" key={index}>
          <Card px="16" py="24">
            <Box display="flex" flex={1} flexDirection="column">
              <Box display="flex" mb="16">
                <Shimmer width="34px" height="24px" />

                <Shimmer ml="8" width="50%" height="24px" />
              </Box>

              <Box
                as="ul"
                p={0}
                css={`
                  list-style: none;
                `}
              >
                {times(4).map(itemsIndex => (
                  <Box
                    as="li"
                    display="flex"
                    justifyContent="space-between"
                    mb="8"
                    key={itemsIndex}
                  >
                    <Shimmer width="50%" height="20px" />

                    <Shimmer width="50px" height="20px" />
                  </Box>
                ))}
              </Box>
            </Box>
          </Card>
        </Box>
      ))}
    </GridWrapper>
  );
};
